/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Row } from './Row';
import {
    RowFromJSON,
    RowFromJSONTyped,
    RowToJSON,
} from './Row';

/**
 * Optional lightweight table [used by LightTable]
 * @export
 * @interface LightTable
 */
export interface LightTable {
    /**
     * 
     * @type {string}
     * @memberof LightTable
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof LightTable
     */
    id: string;
    /**
     * Whether additional rows can be added (edit only)
     * @type {boolean}
     * @memberof LightTable
     */
    canAddRows?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LightTable
     */
    noDataAvailableLabel?: string;
    /**
     * The description why the table is not editable (edit only)
     * @type {string}
     * @memberof LightTable
     */
    notEditableDescription?: string;
    /**
     * 
     * @type {Array<Row>}
     * @memberof LightTable
     */
    rows: Array<Row>;
    /**
     * The description why no additional rows can be added (edit only)
     * @type {string}
     * @memberof LightTable
     */
    rowsCannotBeAddedDescription?: string;
    /**
     * 
     * @type {Row}
     * @memberof LightTable
     */
    templateRow?: Row;
    /**
     * Whether the table is editable (edit only)
     * @type {boolean}
     * @memberof LightTable
     */
    editable?: boolean;
    /**
     * Whether at least one row is required (edit only)
     * @type {boolean}
     * @memberof LightTable
     */
    required?: boolean;
}

/**
 * Check if a given object implements the LightTable interface.
 */
export function instanceOfLightTable(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "rows" in value;

    return isInstance;
}

export function LightTableFromJSON(json: any): LightTable {
    return LightTableFromJSONTyped(json, false);
}

export function LightTableFromJSONTyped(json: any, ignoreDiscriminator: boolean): LightTable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'id': json['id'],
        'canAddRows': !exists(json, 'canAddRows') ? undefined : json['canAddRows'],
        'noDataAvailableLabel': !exists(json, 'noDataAvailableLabel') ? undefined : json['noDataAvailableLabel'],
        'notEditableDescription': !exists(json, 'notEditableDescription') ? undefined : json['notEditableDescription'],
        'rows': ((json['rows'] as Array<any>).map(RowFromJSON)),
        'rowsCannotBeAddedDescription': !exists(json, 'rowsCannotBeAddedDescription') ? undefined : json['rowsCannotBeAddedDescription'],
        'templateRow': !exists(json, 'templateRow') ? undefined : RowFromJSON(json['templateRow']),
        'editable': !exists(json, 'editable') ? undefined : json['editable'],
        'required': !exists(json, 'required') ? undefined : json['required'],
    };
}

export function LightTableToJSON(value?: LightTable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'id': value.id,
        'canAddRows': value.canAddRows,
        'noDataAvailableLabel': value.noDataAvailableLabel,
        'notEditableDescription': value.notEditableDescription,
        'rows': ((value.rows as Array<any>).map(RowToJSON)),
        'rowsCannotBeAddedDescription': value.rowsCannotBeAddedDescription,
        'templateRow': RowToJSON(value.templateRow),
        'editable': value.editable,
        'required': value.required,
    };
}

